import { render, staticRenderFns } from "./EcosystemConnectionRequests.vue?vue&type=template&id=7fa527be&scoped=true"
import script from "./EcosystemConnectionRequests.vue?vue&type=script&lang=js"
export * from "./EcosystemConnectionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa527be",
  null
  
)

export default component.exports